import { PATHS, SETTINGS_CARDS } from '@Utils/constants';
import { SectionCard, useTopHat } from '@kg-internal/pv3-uikit';
import { useNavigate } from 'react-router-dom';
import styles from './Settings.module.scss';

const Settings = () => {
  const block = 'settings-container';

  const navigate = useNavigate();

  useTopHat({
    activeNav: 'nav-settings',
    activeTab: undefined,
    tabs: [],
    breadcrumbs: [{ title: 'Settings', href: PATHS.SETTINGS, id: 'Settings' }],
  });

  return (
    <div className={`grid ${styles[block]}`}>
      {SETTINGS_CARDS.map((cardInfo) => (
        <div className={`col-12 col-md-3 ${styles[`${block}__card`]}`} key={`${cardInfo.name}-card`}>
          <button
            className={styles[`${block}__button`]}
            type='button'
            aria-label={`${cardInfo.name} button`}
            onClick={() => navigate(cardInfo.path)}>
            <SectionCard className={styles[`${block}__section-card`]}>
              <div>
                <img className={styles[`${block}__image`]} src={cardInfo.image} alt={cardInfo.name} />
                <br />
                <br />
                <hr className='divider' />
                <div className={styles[`${block}__title-container`]}>
                  <h2 className={styles[`${block}__title-container--title`]}>{cardInfo.name}</h2>
                </div>
              </div>
              <span className={styles[`${block}__shadow`]} />
            </SectionCard>
          </button>
        </div>
      ))}
    </div>
  );
};

export default Settings;
